import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, timer } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { PathConfig } from '../config/path.config';
import { ClientDetailService } from './client-detail-service';
import { HttpService } from './http.service';
import { ThemeService } from './theme.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ClientLogoService {
  private readonly logoSubject = new BehaviorSubject<string>('');
  readonly logo$ = this.logoSubject.asObservable();
  private readonly refreshInterval = 9 * 60 * 1000;

  constructor(
    private httpService: HttpService,
    private clientDetailService: ClientDetailService,
    private themeService: ThemeService
  ) {
    timer(this.refreshInterval, this.refreshInterval)
      .pipe(
        switchMap(() => this.refreshLogo().pipe(catchError(() => EMPTY)))
      )
      .subscribe();
  }

  refreshLogo(): Observable<string> {
    const theme = (this.themeService.theme || 'light').toLowerCase();
    const logoPath = this.clientDetailService.CLIENT_LOGO(theme);

    if (!logoPath) {
      return EMPTY;
    }

    const url = `${PathConfig.TEMP_FILE}?path=${logoPath}&storage_disk=s3`;

    return this.httpService.get(url).pipe(
      map((response) => response?.temporary_url || ''),
      tap((logo) => {
        if (logo) {
          this.logoSubject.next(logo);
        }
      })
    );
  }

  getLogo(): string {
    const theme = (this.themeService.theme || 'light').toLowerCase();
    const logoPath = this.clientDetailService.CLIENT_LOGO(theme);
    return logoPath ? environment.IMG_URL + logoPath : '';
  }
}